import { cx } from 'common/utils/cx';
import { ReactNode } from 'react';
import { BasicProps } from 'antd/lib/layout/layout';

import { Card, Typography } from '../../components';

interface Props {
  children: ReactNode;
}

export default function QuestionWrapper({ children }: Props) {
  return (
    <div className="question-wrapper">
      <Card>{children}</Card>
    </div>
  );
}

QuestionWrapper.Divider = ({ children, type = 'default' }: { type?: 'default' | 'bordered' } & BasicProps) => (
  <div
    className={cx('question-wrapper-divider', {
      'question-wrapper-divider-bordered': type === 'bordered',
    })}
  >
    {children}
  </div>
);

QuestionWrapper.Title = ({ children }: BasicProps) => (
  <Typography.Title level={4} className="question-wrapper-title">
    {children}
  </Typography.Title>
);
